window.addEventListener('DOMContentLoaded', () => {

    const form = document.querySelector('form.twz-vacancy-filters');
    if (form) {
        const formInputs = form.querySelectorAll('input');

        formInputs.forEach(input => input.addEventListener('click', () => {
            console.log('click')
            console.log('has been changed')
            form.submit();
        }));
    }


});